import QrCodeCheckProvider from './QrCodeCheckContext';
import QrCodeCheck from './QrCodeCheck';


let Index = () => {
    return (
        <QrCodeCheckProvider>
            <QrCodeCheck />
        </QrCodeCheckProvider>
    )
}

export default Index;